import { InjectionToken } from "@angular/core";

export const SOFTLINE_FEATURE_PWA_UPDATE = 'pwaUpdate';
export const SOFTLINE_FEATURE_PWA_INSTALL = 'pwaInstall';
export const SOFTLINE_SETTINGS_PWA_UPDATE = 'pwaUpdate';
export const SOFTLINE_SETTINGS_PWA_INSTALL = 'pwaInstall';
export const SOFTLINE_CONFIG_PWA_CHECK_UPDATE_INTERVALL = new InjectionToken<number>('SOFTLINE_CONFIG_PWA_CHECK_UPDATE_INTERVALL')
